function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  d: "M2.5 296h396"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeDasharray: "6",
  strokeLinecap: "round",
  d: "M5.5 148h393"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M302.4 396V118l-2-4-2 4v278zm-103.5-48.7h4v-59.7l-2-4-2 4z"
}), React.createElement("path", {
  stroke: "#B93296",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M2.5 396h396"
}), React.createElement("g", {
  stroke: "#46C3D7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M0 346.5c4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.7-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4-2 8.7-2 12.8 0 4.2 2 8.8 2 13 0 4-2 8.6-2 12.7 0 4.2 2 8.8 2 13 0 4-2 8.7-2 12.8 0 4.1 2 8.7 2 12.9 0 4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0 8.7 2 12.8 0c4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.7-2 12.9 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0"
}), React.createElement("path", {
  d: "M0 356.5c4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.7-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4-2 8.7-2 12.8 0 4.2 2 8.8 2 13 0 4-2 8.6-2 12.7 0 4.2 2 8.8 2 13 0 4-2 8.7-2 12.8 0 4.1 2 8.7 2 12.9 0 4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0 8.7 2 12.8 0c4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.7-2 12.9 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0m-399 10c4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.7-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4-2 8.7-2 12.8 0 4.2 2 8.8 2 13 0 4-2 8.6-2 12.7 0 4.2 2 8.8 2 13 0 4-2 8.7-2 12.8 0 4.1 2 8.7 2 12.9 0 4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0 8.7 2 12.8 0c4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.7-2 12.9 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0m-399 10c4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.7-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4-2 8.7-2 12.8 0 4.2 2 8.8 2 13 0 4-2 8.6-2 12.7 0 4.2 2 8.8 2 13 0 4-2 8.7-2 12.8 0 4.1 2 8.7 2 12.9 0 4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0 8.7 2 12.8 0c4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.7-2 12.9 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0m-399 10c4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.7-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4-2 8.7-2 12.8 0 4.2 2 8.8 2 13 0 4-2 8.6-2 12.7 0 4.2 2 8.8 2 13 0 4-2 8.7-2 12.8 0 4.1 2 8.7 2 12.9 0 4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0c4 2 8.7 2 12.8 0 4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0s8.7 2 12.9 0c4-2 8.7-2 12.8 0 4.1 2 8.8 2 12.9 0s8.8-2 12.9 0 8.7 2 12.8 0c4.2-2 8.8-2 13 0 4 2 8.7 2 12.8 0 4.1-2 8.7-2 12.9 0 4 2 8.7 2 12.8 0 4.1-2 8.8-2 12.9 0",
  opacity: 0.2
})), React.createElement("g", {
  fillRule: "nonzero",
  transform: "rotate(14 14 984.1)"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M136.2 3l-10-2.3c-3.9-.9-8-.8-11.8.2L34 22.5h-2.4c-2.4.2-4.8-.5-6.7-1.9L7.7 8.6C6.9 8 5.9 7.7 4.9 8L.4 9.3a.5.5 0 0 0-.3.7l11 19.8L4.2 33c-.1 0-.2.2-.1.3l.5 2c0 .1.1.2.3.2h22.5c9 .1 17.8-1 26.4-3.4L111 16.8c8.6-2.3 17-5.5 25-9.5a2.7 2.7 0 0 0 1.4-3c-.1-.6-.6-1.1-1.2-1.3z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M53.8 32L111 16.7c8.7-2.3 17-5.5 25-9.5a2.7 2.7 0 0 0 1.5-3c-.2-.6-.7-1.1-1.3-1.2l-10-2.4c-3.9-.9-8-.8-11.8.2l-.6.2a20 20 0 0 1-14.2 14.7L26 35.5h1.4A101 101 0 0 0 53.8 32zm-31.6-2.5L8 30.3l-5.5 1.4 7.7 1.5h.8l11.5-3 .2-.2a.3.3 0 0 0-.4-.5z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M25 20.6l-8-5.5 2 2.4a7 7 0 0 1-1.4 10.1l1-.2 15.3-5-2.4.1c-2.4.2-4.7-.5-6.7-1.9z",
  opacity: 0.1
}), React.createElement("path", {
  fill: "#071920",
  d: "M126.3 3.4l5.3-1.5-4.3-1-4.6 1.2z",
  opacity: 0.4
}), React.createElement("rect", {
  width: 3.615,
  height: 7.231,
  x: 121,
  y: 1.2,
  fill: "#071920",
  opacity: 0.4,
  rx: 1.8,
  transform: "rotate(-15 122.8 4.8)"
}), React.createElement("rect", {
  width: 3.615,
  height: 7.231,
  x: 33.2,
  y: 24.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.8,
  transform: "rotate(-15 35 28.4)"
}), React.createElement("rect", {
  width: 2.27,
  height: 3.88,
  x: 84.6,
  y: 12.1,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.08,
  transform: "rotate(-15 85.7 14)"
}), React.createElement("rect", {
  width: 2.27,
  height: 3.88,
  x: 81.6,
  y: 12.9,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.08,
  transform: "rotate(-15 82.8 14.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 112.7,
  y: 5.7,
  fill: "#071920",
  rx: 0.4,
  transform: "rotate(-15 113.1 6.3)"
}), React.createElement("path", {
  fill: "#145569",
  d: "M111.6 6.6v-.1c0-.2-.3-.3-.5-.3a.4.4 0 0 0-.3.5l.1.4.3.2.4-.7z",
  opacity: 0.1
}), React.createElement("path", {
  fill: "#071920",
  d: "M111.7 6.9v-.3l-.5.7h.2c.2 0 .3-.2.3-.4z"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 109,
  y: 6.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 109.4 7.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 107.1,
  y: 7.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 107.5 7.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 105.2,
  y: 7.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 105.6 8.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 103.3,
  y: 8.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 103.7 8.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.185,
  x: 105.1,
  y: 8.5,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 105.5 9)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 99.5,
  y: 9.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 100 9.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 97.6,
  y: 9.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 98 10.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 95.7,
  y: 10.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 96.1 10.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 93.8,
  y: 10.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 94.2 11.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 91.9,
  y: 11.3,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 92.3 11.9)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 90,
  y: 11.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 90.4 12.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 88.1,
  y: 12.3,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 88.5 12.9)"
}), React.createElement("rect", {
  width: 1,
  height: 1.185,
  x: 88.8,
  y: 12.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 89.2 13.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 82.3,
  y: 13.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 82.7 14.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 79.3,
  y: 14.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 79.7 15.2)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 77.4,
  y: 15.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 77.8 15.7)"
}), React.createElement("rect", {
  width: 1,
  height: 1.185,
  x: 79.1,
  y: 15.5,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 79.5 16)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 73.6,
  y: 16.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 74 16.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 71.7,
  y: 16.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 72 17.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.185,
  x: 73.4,
  y: 17,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 73.8 17.6)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 67.9,
  y: 17.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 68.3 18.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 66,
  y: 18.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 66.4 18.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 64.1,
  y: 18.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 64.5 19.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 62.2,
  y: 19.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 62.6 19.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 60.3,
  y: 19.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 60.7 20.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 58.4,
  y: 20.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 58.8 20.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 56.5,
  y: 20.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 57 21.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 54.7,
  y: 21.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 55 21.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 52.8,
  y: 21.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 53.2 22.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 50.9,
  y: 22.3,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 51.3 22.9)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 49,
  y: 22.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 49.4 23.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 47.1,
  y: 23.3,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 47.5 23.9)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 45.2,
  y: 23.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 45.6 24.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 43.3,
  y: 24.3,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 43.7 24.9)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 41.4,
  y: 24.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 41.8 25.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 39.5,
  y: 25.3,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 40 25.9)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 37.6,
  y: 25.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 38 26.4)"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M64.4 19.6c-2.2.2-4.5-.4-6.3-1.8l-7-5.3c-.4-.3-.9-.4-1.3-.2l-1 .2a.2.2 0 0 0-.2.3L55 20a4 4 0 0 0 2.7 1.4l6.8-1.9z"
}), React.createElement("path", {
  fill: "#071920",
  d: "M95.2 16.9l-30.8 2.7-6.8 1.9L78.9 23c2.1.2 4.2 0 6.2-.7L96.3 19a1 1 0 0 0 .4-1.7c-.4-.3-1-.5-1.5-.4z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M84.3 25.5l3.1-.8-1.4-5.3-12.8 3.4a.1.1 0 0 0 0 .3l4.1 1.9c2.2 1 4.7 1.1 7 .5z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M92 24.4l4.2-1.1-2-7-16.9 4.5a.2.2 0 0 0 0 .3l5.5 2.5c3 1.3 6.2 1.6 9.2.8z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M96.2 23.3c-1.2.3-2.4-1-3-3-.5-2 0-3.8 1-4 1.2-.3 2.4 1 3 3 .5 2 0 3.7-1 4z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M95 18.8c-.3 0-.5.6-.3 1.1.1.6.5.9.8.8a1 1 0 0 0-.5-1.9z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M4.3 33l.9-.5.7 3H5l-.2-.2-.6-2c0-.2 0-.3.2-.3z"
})), React.createElement("g", {
  fillRule: "nonzero",
  transform: "rotate(15 -674.6 621.2)"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M136.2 3l-10-2.4c-3.9-.9-7.9-.8-11.7.2L33.9 22.4l-2.4.1c-2.4.1-4.7-.6-6.7-2L7.6 8.6C6.8 7.8 6 7.6 5 8L.4 9.2a.5.5 0 0 0-.3.7l11 19.8L4.2 33c-.1 0-.2.2-.1.3l.5 2c0 .2.1.3.3.2l22.5.1c8.9 0 17.8-1.1 26.4-3.4L111 16.7c8.6-2.3 17-5.5 25-9.5a2.7 2.7 0 0 0 1.4-3c-.1-.6-.6-1-1.2-1.2z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M53.8 32L111 16.7c8.6-2.3 17-5.5 25-9.5a2.7 2.7 0 0 0 1.4-3c-.1-.7-.6-1.1-1.2-1.2l-10-2.4c-3.9-.9-8-.8-11.8.2l-.6.2v.1a20 20 0 0 1-14.2 14.7L26 35.4h1.4c8.9 0 17.8-1 26.4-3.4zm-31.6-2.6l-14.4.8-5.5 1.5 7.7 1.5h1l11.4-3 .1-.2a.3.3 0 0 0-.3-.6z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M24.8 20.6L17.1 15l1.9 2.4a7 7 0 0 1-1.4 10.1l1-.3 15.3-5-2.4.2c-2.4.1-4.7-.6-6.7-2z",
  opacity: 0.1
}), React.createElement("path", {
  fill: "#071920",
  d: "M126.3 3.3l5.3-1.4-4.4-1-4.5 1.2z",
  opacity: 0.4
}), React.createElement("rect", {
  width: 3.6,
  height: 7.2,
  x: 117.2,
  y: 1.4,
  fill: "#071920",
  opacity: 0.4,
  rx: 1.8,
  transform: "rotate(-15 119 5)"
}), React.createElement("rect", {
  width: 3.6,
  height: 7.2,
  x: 29.7,
  y: 24.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.8,
  transform: "rotate(-15 31.5 28.4)"
}), React.createElement("rect", {
  width: 2.27,
  height: 3.88,
  x: 84.5,
  y: 12.1,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.08,
  transform: "rotate(-15 85.7 14)"
}), React.createElement("rect", {
  width: 2.27,
  height: 3.88,
  x: 81.6,
  y: 12.9,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.08,
  transform: "rotate(-15 82.7 14.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 112.7,
  y: 5.6,
  fill: "#071920",
  rx: 0.4,
  transform: "rotate(-15 113.1 6.2)"
}), React.createElement("path", {
  fill: "#145569",
  d: "M111.6 6.5a.4.4 0 0 0-.8.2l.1.3c0 .2.1.2.2.3l.5-.8z",
  opacity: 0.1
}), React.createElement("path", {
  fill: "#071920",
  d: "M111.7 6.8l-.1-.3-.5.8h.3c.2 0 .3-.3.3-.5z"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 108.9,
  y: 6.6,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 109.3 7.2)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 107,
  y: 7.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 107.4 7.7)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 105.1,
  y: 7.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 105.5 8.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 103.2,
  y: 8.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 103.6 8.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 101.4,
  y: 8.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 101.8 9.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 99.5,
  y: 9.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 99.9 9.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 97.6,
  y: 9.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 98 10.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 95.7,
  y: 10.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 96 10.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 93.8,
  y: 10.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 94.2 11.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 91.9,
  y: 11.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 92.3 11.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 90,
  y: 11.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 90.4 12.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 88.1,
  y: 12.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 88.5 12.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 85.2,
  y: 13,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 85.6 13.6)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 82.2,
  y: 13.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 82.6 14.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 79.2,
  y: 14.6,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 79.6 15.2)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 77.3,
  y: 15.1,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 77.7 15.7)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 75.4,
  y: 15.6,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 75.8 16.2)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 73.5,
  y: 16.1,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 74 16.7)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 71.7,
  y: 16.6,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 72 17.2)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 69.8,
  y: 17.1,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 70.2 17.7)"
}), React.createElement("rect", {
  width: 1,
  height: 1.185,
  x: 71.2,
  y: 18.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 71.6 18.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 66,
  y: 18.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 66.4 18.7)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 64.1,
  y: 18.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 64.5 19.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 62.2,
  y: 19.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 62.6 19.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 60.3,
  y: 19.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 60.7 20.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 58.4,
  y: 20.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 58.8 20.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 56.5,
  y: 20.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 57 21.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 54.6,
  y: 21.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 55 21.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 52.7,
  y: 21.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 53.1 22.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 50.8,
  y: 22.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 51.2 22.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 48.9,
  y: 22.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 49.3 23.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 47,
  y: 23.2,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 47.4 23.8)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 45.2,
  y: 23.7,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 45.6 24.3)"
}), React.createElement("rect", {
  width: 1,
  height: 1.185,
  x: 46.5,
  y: 24.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 47 25.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 41.4,
  y: 24.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 41.8 25.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.185,
  x: 42.7,
  y: 25.9,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 43.1 26.4)"
}), React.createElement("rect", {
  width: 1,
  height: 1.18,
  x: 37.6,
  y: 25.8,
  fill: "#145569",
  opacity: 0.1,
  rx: 0.4,
  transform: "rotate(-15 38 26.4)"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M64.4 19.6c-2.3.2-4.5-.5-6.3-1.8l-7-5.3c-.4-.3-.9-.4-1.4-.3l-1 .3a.2.2 0 0 0-.1.2l6.3 7.4a4 4 0 0 0 2.7 1.3l6.8-1.8z"
}), React.createElement("path", {
  fill: "#071920",
  d: "M95.2 16.8l-30.8 2.8-6.8 1.8 21.3 1.7c2 .1 4.2-.1 6.2-.7l11.1-3.5a1 1 0 0 0 .4-1.6 2 2 0 0 0-1.4-.5z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M84.3 25.4l3-.8-1.3-5.3-13 3.4a.1.1 0 0 0 0 .3l4.2 1.9c2.2 1 4.6 1.2 7 .5z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M92 24.3l4.1-1-1.9-7-16.9 4.5a.2.2 0 0 0 0 .3l5.5 2.5c2.9 1.3 6.1 1.5 9.2.7z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M96.1 23.2c-1.1.3-2.4-1-2.9-3s0-3.7 1-4c1.1-.2 2.4 1 3 3 .5 2 0 3.7-1 4z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M95 18.8c-.4 0-.5.5-.4 1 .2.6.5 1 .8.9.6-.2.9-.7.7-1.2a1 1 0 0 0-1.2-.7z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M4.2 33l1-.5.7 3h-1l-.3-.3-.5-2 .1-.3z"
})), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M18.4 129.7h-3v8.3h-2.1v-8.3h-3V128h8v1.7zm4.2 2.8l-.7-.1c-.7 0-1.2.3-1.4.8v4.8h-2v-7.4h1.8l.1.9c.4-.7 1-1 1.6-1h.7v2zm4.6 5.5l-.2-.7c-.5.6-1.1.8-1.9.8-.7 0-1.3-.2-1.8-.6a2 2 0 0 1-.7-1.6c0-.8.3-1.4.9-1.8.5-.4 1.4-.6 2.5-.6h.9v-.4c0-.4-.1-.7-.3-.9-.2-.2-.4-.3-.8-.3-.3 0-.6.1-.8.3-.2.1-.3.3-.3.6h-2c0-.4.2-.8.4-1.2.3-.3.7-.6 1.2-.8a4 4 0 0 1 1.6-.3c.9 0 1.6.2 2.2.7.5.4.8 1 .8 1.9v3.2c0 .7 0 1.2.3 1.6v.1h-2zm-1.7-1.4c.3 0 .6 0 .8-.2.3-.1.5-.3.6-.5v-1.3H26c-1 0-1.5.4-1.5 1v.2c0 .2 0 .4.2.6l.7.2zm6.2-6v.9c.6-.7 1.3-1 2.2-1 .8 0 1.4.2 1.7.7.4.4.6 1.1.6 2v4.8h-2v-4.7c0-.4 0-.8-.2-1l-1-.2c-.5 0-.9.2-1.2.7v5.2h-2v-7.4h1.9zm9.5 5.4c0-.3 0-.5-.3-.6a4 4 0 0 0-1.2-.4c-1.7-.4-2.6-1.1-2.6-2.2 0-.7.3-1.2.8-1.7.5-.4 1.3-.6 2.1-.6 1 0 1.7.2 2.3.6.5.5.8 1 .8 1.8h-2c0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3-.3 0-.6 0-.7.2-.2.2-.3.3-.3.6 0 .2 0 .4.3.5l1 .4c.5 0 1 .2 1.3.3 1 .4 1.6 1 1.6 2a2 2 0 0 1-1 1.6c-.5.4-1.2.6-2.2.6a4 4 0 0 1-1.6-.3c-.5-.2-.9-.5-1.1-.9-.3-.4-.5-.8-.5-1.3h2c0 .4 0 .7.3.9l1 .2c.4 0 .6 0 .8-.2.2-.1.3-.3.3-.5zm4.8 2h-2v-7.4h2v7.4zm-2-9.3c0-.3 0-.6.2-.7.2-.2.5-.3.8-.3.4 0 .6 0 .8.3.2.1.3.4.3.7 0 .3 0 .5-.3.7-.2.2-.5.3-.8.3-.3 0-.6 0-.8-.3a1 1 0 0 1-.3-.7zm5.5 0v1.9h1.3v1.5h-1.3v3.6c0 .3 0 .5.2.6 0 .2.3.2.6.2h.5v1.5a4 4 0 0 1-1.2.1c-1.3 0-2-.7-2-2v-4h-1.2v-1.5h1.1v-1.8h2zm4 9.3h-2v-7.4h2v7.4zm-2.1-9.3c0-.3 0-.6.2-.7.2-.2.5-.3.9-.3.3 0 .6 0 .8.3.2.1.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.5.3-.8.3-.4 0-.6 0-.8-.3a1 1 0 0 1-.3-.7zm2.9 5.5c0-.7.1-1.4.4-2 .3-.5.7-1 1.2-1.3.5-.3 1.2-.4 1.9-.4 1 0 1.8.3 2.4.9.6.6 1 1.4 1 2.5v.5c0 1.1-.2 2-.9 2.7-.6.7-1.5 1-2.5 1s-2-.3-2.6-1a4 4 0 0 1-1-2.8zm2 .2c0 .7 0 1.2.3 1.6.3.4.7.5 1.2.5s.8-.1 1.1-.5c.3-.4.4-1 .4-1.8 0-.7-.1-1.2-.4-1.6-.3-.3-.7-.5-1.1-.5-.5 0-.9.2-1.2.5a3 3 0 0 0-.4 1.8zm7.5-3.8v.9c.6-.7 1.3-1 2.2-1 .8 0 1.4.2 1.7.7.4.4.6 1.1.6 2v4.8h-2v-4.7c0-.4 0-.8-.2-1l-1-.2c-.5 0-.9.2-1.2.7v5.2h-2v-7.4h2zm12.8 7.4l-.2-.7c-.5.6-1 .8-1.9.8-.7 0-1.3-.2-1.8-.6a2 2 0 0 1-.7-1.6c0-.8.3-1.4.9-1.8.6-.4 1.4-.6 2.5-.6h1v-.4c0-.4-.2-.7-.3-.9-.2-.2-.5-.3-.9-.3-.3 0-.6.1-.8.3l-.2.6h-2c0-.4.1-.8.4-1.2.3-.3.6-.6 1.1-.8a4 4 0 0 1 1.6-.3c1 0 1.7.2 2.2.7.5.4.8 1 .8 1.9v3.2c0 .7.1 1.2.3 1.6v.1h-2zm-1.6-1.4c.3 0 .5 0 .8-.2l.5-.5v-1.3h-.7c-1 0-1.5.4-1.6 1v.2c0 .2 0 .4.3.6l.7.2zm6.4 1.4h-2v-10.5h2V138zm3.5-9.2v1.8h1.3v1.5h-1.3v3.6c0 .3 0 .5.2.6 0 .2.3.2.6.2h.5v1.5a4 4 0 0 1-1.2.1c-1.3 0-2-.7-2-2v-4h-1.2v-1.5H83v-1.8h2zm4 9.2h-2v-7.4h2v7.4zm-2.1-9.3c0-.3 0-.6.3-.7.1-.2.4-.3.8-.3.3 0 .6 0 .8.3.2.1.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.5.3-.8.3-.4 0-.6 0-.8-.3a1 1 0 0 1-.3-.7zm5.5 0v1.9h1.3v1.5h-1.3v3.6l.2.6c.1.2.3.2.6.2h.6v1.5a4 4 0 0 1-1.2.1c-1.4 0-2.1-.7-2.1-2v-4h-1.1v-1.5h1v-1.8h2zm6.3 8.5c-.4.6-1.1 1-2 1-.8 0-1.4-.3-1.8-.7-.4-.5-.6-1.2-.6-2v-4.9h2v4.8c0 .8.3 1.1 1 1.1s1.1-.2 1.4-.7v-5.2h2v7.4h-2v-.8zm2.6-3c0-1.1.3-2 .8-2.7.5-.7 1.2-1 2.1-1 .8 0 1.3.2 1.8.8v-3.8h2V138h-1.8v-.8c-.6.6-1.2 1-2 1s-1.5-.4-2-1c-.6-.8-.9-1.7-.9-3zm2 .2c0 .7.1 1.2.4 1.6.2.4.6.5 1 .5.6 0 1-.2 1.3-.7v-3c-.2-.5-.7-.7-1.3-.7-1 0-1.4.7-1.4 2.3zm9.1 3.7c-1 0-2-.3-2.6-1-.7-.6-1-1.5-1-2.6v-.2c0-.8.1-1.4.4-2 .3-.6.7-1 1.2-1.4.5-.3 1.1-.4 1.8-.4 1 0 1.8.3 2.4 1 .6.6.9 1.5.9 2.6v.8h-4.7c0 .5.2 1 .5 1.2.4.3.8.4 1.3.4.7 0 1.3-.2 1.8-.8l1 1.1a3 3 0 0 1-1.3 1 4 4 0 0 1-1.7.3zm-.2-6c-.4 0-.7.1-1 .4a2 2 0 0 0-.4 1.1h2.7v-.2c0-.4 0-.7-.3-1-.2-.2-.6-.3-1-.3z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M250 86v22h101V86z"
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M261.9 98h-4v4h-2V92h6.5v1.7h-4.5v2.6h4v1.6zm3.1 4h-2V91.5h2V102zm3.2 0h-2v-7.4h2v7.4zm-2-9.3c0-.3 0-.6.2-.7.2-.2.5-.3.8-.3.4 0 .6 0 .8.3.2.1.3.4.3.7 0 .3 0 .5-.3.7-.2.2-.4.3-.8.3-.3 0-.6 0-.8-.3a1 1 0 0 1-.3-.7zm2.9 5.5c0-1 .2-2 .8-2.7.5-.7 1.2-1 2.2-1 .8 0 1.4.2 1.9.8v-.7h1.8v7.2c0 .6-.1 1.2-.4 1.6-.3.5-.7.9-1.3 1.1a4.4 4.4 0 0 1-3.4 0c-.5-.1-1-.4-1.2-.8l.9-1.2c.5.6 1 .9 1.8.9.5 0 1-.2 1.2-.4.3-.3.4-.7.4-1.2v-.4c-.4.5-1 .7-1.8.7s-1.6-.3-2.1-1c-.6-.7-.8-1.6-.8-2.8zm2 .2c0 .7 0 1.2.3 1.6.3.3.7.5 1.2.5.6 0 1-.2 1.2-.6v-3.2c-.2-.4-.6-.6-1.2-.6-.5 0-.9.2-1.2.6a3 3 0 0 0-.4 1.7zm7.7-3c.5-.6 1.2-1 2-1 1.6 0 2.4 1 2.4 2.9v4.7h-2v-4.7c0-.4 0-.7-.3-1-.1-.1-.4-.2-.9-.2s-1 .2-1.2.6v5.3h-2V91.5h2v4zm7.7-2.6v1.8h1.3v1.5h-1.3v3.6l.2.6c.1.2.3.2.6.2h.6v1.5a4 4 0 0 1-1.2.1c-1.4 0-2.1-.7-2.1-2v-4h-1.1v-1.5h1v-1.8h2zm7 9.2h-2V91.5h2V102zm4.5.1c-1 0-2-.3-2.6-1-.7-.6-1-1.5-1-2.6v-.2c0-.8 0-1.4.4-2 .3-.6.7-1 1.2-1.4.5-.3 1.1-.4 1.8-.4 1 0 1.8.3 2.4 1 .6.6.9 1.5.9 2.6v.8h-4.8c.1.5.3 1 .6 1.2.3.3.7.4 1.2.4.8 0 1.4-.2 1.8-.8l1 1.1a3 3 0 0 1-1.2 1 4 4 0 0 1-1.7.3zm-.2-6c-.4 0-.7.1-1 .4a2 2 0 0 0-.4 1.1h2.7v-.2c0-.4-.1-.7-.3-1-.3-.2-.6-.3-1-.3zm6.6 3.5l1.3-5h2l-2.4 7.4h-1.9l-2.5-7.4h2l1.5 5zm7 2.5c-1 0-1.9-.3-2.6-1-.7-.6-1-1.5-1-2.6v-.2c0-.8.1-1.4.4-2a3.4 3.4 0 0 1 3-1.8c1 0 1.9.3 2.4 1 .6.6 1 1.5 1 2.6v.8h-4.8c0 .5.3 1 .6 1.2.3.3.7.4 1.2.4.8 0 1.4-.2 1.8-.8l1 1.1a3 3 0 0 1-1.2 1 4 4 0 0 1-1.7.3zm-.2-6c-.3 0-.7.1-.9.4a2 2 0 0 0-.5 1.1h2.8v-.2c0-.4-.2-.7-.4-1-.2-.2-.5-.3-1-.3zm6 5.9h-2V91.5h2V102zm1.2-1c0-.3.2-.5.4-.7.2-.2.4-.3.8-.3.3 0 .6 0 .8.3.2.2.3.4.3.7 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3a1 1 0 0 1-.4-.8zm0-5.6c0-.3.2-.5.4-.7.2-.2.4-.3.8-.3.3 0 .6 0 .8.3.2.2.3.4.3.7 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3a1 1 0 0 1-.4-.8zm11.1 6.6h-2v-7.6l-2.3.7v-1.6l4-1.5h.3v10zm8.6-3.7h1.1v1.5h-1.1v2.2h-2v-2.2h-4l-.2-1.2 4.2-6.6h2v6.3zm-4.2 0h2.2v-3.6l-.1.3-2 3.3zm12.6-.4a5 5 0 0 1-.9 3.1c-.6.8-1.4 1.1-2.5 1.1-1 0-1.9-.3-2.5-1-.5-.8-.8-1.8-.9-3.1v-1.8c0-1.4.3-2.5 1-3.2a3 3 0 0 1 2.4-1c1 0 2 .3 2.5 1 .6.7.9 1.7.9 3v2zm-2-2c0-.8-.1-1.5-.3-1.8-.3-.4-.6-.6-1.1-.6-.5 0-.8.2-1 .5-.3.4-.4 1-.4 1.7v2.4c0 .9.1 1.5.4 1.9.2.3.5.5 1 .5s.8-.1 1-.5c.3-.4.4-1 .4-1.8V96z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M2 385v22h102v-22z"
}), React.createElement("path", {
  fill: "#071920",
  fillRule: "nonzero",
  d: "M10 401H8v-10h2v10zm6.6-2.6a1 1 0 0 0-.4-.9l-1.5-.7-1.6-.6c-1.2-.7-1.7-1.5-1.7-2.5 0-.5.1-1 .4-1.4a3 3 0 0 1 1.3-1 5 5 0 0 1 2-.4c.6 0 1.3.1 1.8.4.6.3 1 .6 1.3 1 .3.6.5 1 .5 1.7h-2c0-.5-.2-.8-.5-1-.3-.3-.7-.5-1.2-.5s-.9.1-1.2.4a1 1 0 0 0-.4.8c0 .3.2.6.5.8l1.4.6c1.2.4 2 .8 2.6 1.3.5.6.8 1.2.8 2s-.3 1.5-1 2c-.6.5-1.5.7-2.6.7a5 5 0 0 1-2.1-.4c-.6-.3-1.1-.6-1.5-1.1a3 3 0 0 1-.4-1.7h2c0 1 .7 1.6 2 1.6a2 2 0 0 0 1.1-.3c.3-.2.4-.5.4-.8zm8.6.5h-3.6l-.7 2.1h-2.2l3.7-10h2l3.7 10h-2.2l-.7-2zm-3-1.6h2.4l-1.2-3.7-1.2 3.7zm13.4 3.7l-.2-.7c-.4.6-1 .8-1.8.8s-1.4-.2-1.8-.6a2 2 0 0 1-.7-1.6c0-.8.2-1.4.8-1.8.6-.4 1.5-.6 2.5-.6h1v-.4c0-.4-.1-.7-.3-.9-.2-.2-.5-.3-.8-.3-.4 0-.6.1-.8.3-.2.1-.3.3-.3.6h-2c0-.4.2-.8.4-1.2l1.1-.8a4 4 0 0 1 1.7-.3c.9 0 1.6.2 2.1.7.6.4.8 1 .8 1.9v3.2c0 .7.1 1.2.3 1.6v.1h-2zm-1.6-1.4c.3 0 .6 0 .8-.2.3-.1.4-.3.6-.5v-1.3h-.8c-1 0-1.5.4-1.6 1v.2l.3.6.7.2zm6.7-7.8v1.8H42v1.5h-1.3v3.6c0 .3 0 .5.2.6 0 .2.3.2.6.2h.6v1.5a4 4 0 0 1-1.2.1c-1.4 0-2.1-.7-2.2-2v-4h-1v-1.5h1v-1.8h2zm9.6 9.2h-2v-7.6l-2.3.7v-1.6l4-1.5h.3v10zm9.4-4.1a5 5 0 0 1-.8 3.1c-.6.8-1.4 1.1-2.5 1.1s-2-.3-2.5-1c-.6-.8-.9-1.8-.9-3.1v-1.8c0-1.4.3-2.5.9-3.2a3 3 0 0 1 2.5-1c1 0 1.9.3 2.4 1 .6.7 1 1.7 1 3v1.9zm-2-2c0-.8 0-1.5-.3-1.8-.2-.4-.6-.6-1-.6-.5 0-.9.2-1 .5-.3.4-.4 1-.4 1.7v2.4c0 .9 0 1.5.3 1.9.2.3.6.5 1 .5.6 0 .9-.1 1.1-.5.2-.4.3-1 .3-1.8V395zm7.7 6.1h-2v-7.6l-2.4.7v-1.6l4.1-1.5h.3v10zm4.7-5.9h1c.6 0 1 0 1.2-.3.2-.3.3-.6.3-1s0-.7-.3-1c-.3-.2-.6-.3-1-.3s-.7.1-1 .3a1 1 0 0 0-.4.8h-2c0-.5.2-1 .5-1.4.3-.4.7-.7 1.2-1a4 4 0 0 1 1.6-.3c1 0 2 .3 2.5.8.6.5.9 1.2.9 2 0 .5-.1 1-.4 1.3-.3.4-.7.7-1.1.9.6.2 1 .5 1.2.9.3.4.5.9.5 1.4 0 .9-.4 1.6-1 2.1-.7.6-1.5.8-2.6.8-1 0-1.8-.2-2.4-.7-.6-.6-1-1.3-1-2.1h2c0 .3.2.7.4.9.3.2.7.3 1 .3.6 0 1 0 1.2-.3.3-.3.4-.6.4-1 0-1-.6-1.5-1.7-1.5h-1V395zm10.4-1.5l.1.8c.5-.6 1.2-1 2.1-1 1 0 1.6.4 2 1.2.5-.8 1.3-1.1 2.2-1.1.8 0 1.4.2 1.8.7.4.4.6 1.1.6 2v4.8h-2v-4.7c0-.4 0-.7-.2-1l-.9-.2c-.6 0-1 .3-1.2.8v5.1h-2v-4.7c0-.4 0-.7-.3-1l-.8-.2c-.6 0-1 .2-1.2.7v5.2h-2v-7.4h1.8zm16.5 3.8c0 1.2-.3 2-.8 2.7-.5.7-1.2 1-2.1 1-.8 0-1.4-.3-2-.9v.8h-1.8v-10.5h2v3.8c.4-.6 1-.8 1.8-.8.9 0 1.6.3 2.1 1 .5.6.8 1.6.8 2.8zm-2-.2c0-.7-.1-1.3-.4-1.6-.2-.4-.5-.5-1-.5-.6 0-1 .2-1.3.7v3c.2.5.7.7 1.3.7.6 0 1-.3 1.3-.9l.1-1.4z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M2.5 336v22h100v-22z"
}), React.createElement("path", {
  fill: "#071920",
  fillRule: "nonzero",
  d: "M11 342l2.6 7.3 2.6-7.3h2.7v10h-2.1v-2.7l.2-4.7-2.7 7.4H13l-2.7-7.4.2 4.7v2.7h-2v-10H11zm12.4 10.1c-1 0-2-.3-2.6-1-.7-.6-1-1.5-1-2.6v-.2c0-.8.1-1.4.4-2 .3-.6.7-1 1.2-1.4.5-.3 1.1-.4 1.8-.4 1 0 1.8.3 2.4 1 .6.6.9 1.5.9 2.6v.8h-4.7c0 .5.2 1 .5 1.2.4.3.8.4 1.3.4.7 0 1.3-.2 1.7-.8l1 1.1a3 3 0 0 1-1.2 1 4 4 0 0 1-1.7.3zm-.2-6c-.4 0-.7.1-1 .4a2 2 0 0 0-.4 1.1h2.7v-.2c0-.4-.1-.7-.3-1-.3-.2-.6-.3-1-.3zm8.2 5.9l-.2-.7c-.5.6-1.1.8-1.9.8-.7 0-1.3-.2-1.8-.6a2 2 0 0 1-.7-1.6c0-.8.3-1.4.9-1.8.5-.4 1.4-.6 2.5-.6h.9v-.4c0-.4 0-.7-.3-.9-.1-.2-.4-.3-.8-.3-.3 0-.6.1-.8.3-.2.1-.3.3-.3.6h-2c0-.4.2-.8.5-1.2.2-.3.6-.6 1-.8a4 4 0 0 1 1.7-.3c1 0 1.6.2 2.2.7.5.4.8 1 .8 1.9v3.2c0 .7 0 1.2.3 1.6v.1h-2zm-1.7-1.4c.3 0 .6 0 .8-.2.3-.1.5-.3.6-.5v-1.3h-.7c-1 0-1.6.4-1.6 1v.2c0 .2 0 .4.2.6l.7.2zm6.2-6v.9c.6-.7 1.3-1 2.2-1 .8 0 1.4.2 1.8.7.3.4.5 1.1.5 2v4.8h-2v-4.7c0-.4 0-.8-.2-1l-1-.2c-.5 0-.9.2-1.2.7v5.2h-2v-7.4h2zm12.5 5.4c0-.3 0-.5-.3-.6a4 4 0 0 0-1.2-.4c-1.7-.4-2.6-1.1-2.6-2.2 0-.7.3-1.2.8-1.7.5-.4 1.3-.6 2.1-.6 1 0 1.7.2 2.3.6.5.5.8 1 .8 1.8h-2c0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3-.3 0-.6 0-.7.2-.2.2-.3.3-.3.6 0 .2 0 .4.3.5l1 .4c.5 0 1 .2 1.3.3 1 .4 1.5 1 1.5 2a2 2 0 0 1-.8 1.6c-.6.4-1.3.6-2.3.6a4 4 0 0 1-1.6-.3c-.5-.2-.9-.5-1.1-.9-.3-.4-.5-.8-.5-1.3h2c0 .4 0 .7.3.9l1 .2c.4 0 .6 0 .8-.2.2-.1.3-.3.3-.5zm6.1 2.1c-1 0-2-.3-2.6-1-.7-.6-1-1.5-1-2.6v-.2c0-.8.1-1.4.4-2 .3-.6.7-1 1.2-1.4.5-.3 1.1-.4 1.8-.4 1 0 1.8.3 2.4 1 .6.6.9 1.5.9 2.6v.8h-4.7c0 .5.2 1 .5 1.2.4.3.8.4 1.3.4.7 0 1.3-.2 1.7-.8l1 1.1a3 3 0 0 1-1.2 1 4 4 0 0 1-1.7.3zm-.2-6c-.4 0-.7.1-1 .4a2 2 0 0 0-.4 1.1h2.7v-.2c0-.4-.1-.7-.3-1-.3-.2-.6-.3-1-.3zm8.2 5.9l-.2-.7c-.5.6-1.1.8-1.9.8-.7 0-1.3-.2-1.8-.6a2 2 0 0 1-.7-1.6c0-.8.3-1.4.9-1.8.5-.4 1.4-.6 2.5-.6h.9v-.4c0-.4 0-.7-.3-.9-.1-.2-.4-.3-.8-.3-.3 0-.6.1-.8.3-.2.1-.3.3-.3.6h-2c0-.4.2-.8.5-1.2.2-.3.6-.6 1-.8a4 4 0 0 1 1.7-.3c1 0 1.6.2 2.2.7.5.4.8 1 .8 1.9v3.2c0 .7 0 1.2.3 1.6v.1h-2zm-1.7-1.4c.3 0 .6 0 .8-.2.3-.1.5-.3.6-.5v-1.3h-.7c-1 0-1.6.4-1.6 1v.2c0 .2 0 .4.2.6l.7.2zm9.5 1.4h-2v-10.5h2V352zm4.5.1c-1 0-2-.3-2.7-1-.6-.6-1-1.5-1-2.6v-.2c0-.8.2-1.4.5-2 .2-.6.7-1 1.2-1.4.5-.3 1.1-.4 1.8-.4 1 0 1.8.3 2.4 1 .5.6.8 1.5.8 2.6v.8h-4.7c0 .5.3 1 .6 1.2.3.3.7.4 1.2.4.8 0 1.4-.2 1.8-.8l1 1.1a3 3 0 0 1-1.2 1 4 4 0 0 1-1.7.3zm-.2-6c-.4 0-.7.1-1 .4a2 2 0 0 0-.5 1.1H76v-.2c0-.4-.1-.7-.4-1-.2-.2-.5-.3-1-.3zm6.5 3.5l1.4-5h2l-2.4 7.4h-1.9l-2.5-7.4h2l1.4 5zm7.2 2.5c-1.1 0-2-.3-2.7-1-.7-.6-1-1.5-1-2.6v-.2c0-.8.1-1.4.4-2 .3-.6.7-1 1.2-1.4.6-.3 1.2-.4 1.8-.4 1 0 1.9.3 2.4 1 .6.6.9 1.5.9 2.6v.8h-4.7c0 .5.3 1 .6 1.2.3.3.7.4 1.2.4.8 0 1.3-.2 1.8-.8l1 1.1a3 3 0 0 1-1.3 1 4 4 0 0 1-1.6.3zm-.3-6c-.4 0-.7.1-1 .4a2 2 0 0 0-.4 1.1h2.8v-.2c0-.4-.2-.7-.4-1-.2-.2-.5-.3-1-.3zm6 5.9h-2v-10.5h2V352z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#FFF",
  d: "M145 255v22h111v-22z"
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M157 269h-3.6l-.7 2h-2.2l3.8-10h1.9l3.7 10h-2.2l-.7-2zm-3-1.7h2.5l-1.3-3.7-1.2 3.7zm8.3 3.7h-2v-10.5h2V271zm3.5-9.2v1.8h1.2v1.5h-1.2v3.6l.1.6c.1.2.3.2.6.2h.6v1.5a4 4 0 0 1-1.2.1c-1.4 0-2-.7-2.1-2v-4h-1.1v-1.5h1v-1.8h2zm4 9.2h-2v-7.4h2v7.4zm-2.2-9.3c0-.3.1-.6.3-.7.2-.2.5-.3.8-.3.4 0 .6 0 .8.3.2.1.3.4.3.7 0 .3 0 .5-.3.7-.2.2-.5.3-.8.3-.3 0-.6 0-.8-.3a1 1 0 0 1-.3-.7zm5.6 0v1.9h1.3v1.5h-1.3v3.6c0 .3 0 .5.2.6 0 .2.3.2.6.2h.5v1.5a4 4 0 0 1-1.2.1c-1.3 0-2-.7-2-2v-4H170v-1.5h1.1v-1.8h2zm6.3 8.5c-.5.6-1.2 1-2 1s-1.4-.3-1.8-.7c-.5-.5-.7-1.2-.7-2v-4.9h2v4.8c0 .8.3 1.1 1 1.1s1.2-.2 1.4-.7v-5.2h2v7.4h-1.9v-.8zm2.6-3c0-1.1.2-2 .8-2.7.5-.7 1.2-1 2-1s1.4.2 1.9.8v-3.8h2V271H187l-.1-.8c-.5.6-1.2 1-2 1s-1.5-.4-2-1c-.5-.8-.8-1.7-.8-3zm2 .2c0 .7 0 1.2.3 1.6.3.4.6.5 1 .5.7 0 1.1-.2 1.4-.7v-3c-.3-.5-.7-.7-1.3-.7-1 0-1.4.7-1.4 2.3zm9 3.7c-1 0-1.9-.3-2.6-1-.6-.6-1-1.5-1-2.6v-.2c0-.8.2-1.4.5-2 .2-.6.6-1 1.2-1.4.5-.3 1.1-.4 1.8-.4 1 0 1.8.3 2.4 1 .5.6.8 1.5.8 2.6v.8h-4.7c0 .5.3 1 .6 1.2.3.3.7.4 1.2.4.8 0 1.4-.2 1.8-.8l1 1.1a3 3 0 0 1-1.2 1 4 4 0 0 1-1.7.3zm-.1-6c-.4 0-.7.1-1 .4a2 2 0 0 0-.5 1.1h2.8v-.2c0-.4-.1-.7-.4-1-.2-.2-.5-.3-1-.3zm4 5c0-.4 0-.6.3-.8.2-.2.4-.3.8-.3.3 0 .6 0 .8.3.2.2.3.4.3.7 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3a1 1 0 0 1-.4-.8zm0-5.7c0-.3 0-.5.3-.7.2-.2.4-.3.8-.3.3 0 .6 0 .8.3.2.2.3.4.3.7 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3a1 1 0 0 1-.4-.8zm12 2.9h1.2v1.5H209v2.2h-2v-2.2h-4v-1.2l4-6.6h2v6.3zm-4.1 0h2.2v-3.6l-.2.3-2 3.3zm6.4 6.2l-1-.5.2-.5c.4-.5.5-1.1.5-1.7v-1.5h1.7v1.4c0 .5-.1 1-.4 1.5a4 4 0 0 1-1 1.3zm9-6.6a5 5 0 0 1-.8 3.1c-.6.8-1.4 1.1-2.5 1.1-1 0-2-.3-2.5-1-.6-.8-.9-1.8-.9-3.1v-1.8c0-1.4.3-2.5.9-3.2a3 3 0 0 1 2.5-1c1 0 1.9.3 2.5 1 .6.7.8 1.7.9 3v1.9zm-2-2c0-.8 0-1.5-.3-1.8-.2-.4-.5-.6-1-.6s-.8.2-1 .5c-.3.4-.4 1-.4 1.7v2.4c0 .9.1 1.5.3 1.9.3.3.6.5 1.1.5.5 0 .8-.1 1-.5.3-.4.4-1 .4-1.8V265zm9.6 2a5 5 0 0 1-.9 3.1c-.5.8-1.4 1.1-2.5 1.1-1 0-1.9-.3-2.5-1-.5-.8-.8-1.8-.8-3.1v-1.8c0-1.4.3-2.5.8-3.2a3 3 0 0 1 2.5-1c1.1 0 2 .3 2.5 1 .6.7.9 1.7.9 3v1.9zm-2-2c0-.8-.1-1.5-.3-1.8-.2-.4-.6-.6-1-.6-.5 0-.9.2-1.1.5-.2.4-.3 1-.4 1.7v2.4c0 .9.2 1.5.4 1.9.2.3.5.5 1 .5s.9-.1 1-.5c.3-.4.4-1 .4-1.8V265zm9.5 2a5 5 0 0 1-.8 3.1c-.6.8-1.4 1.1-2.5 1.1s-2-.3-2.5-1c-.6-.8-.9-1.8-.9-3.1v-1.8c0-1.4.3-2.5.9-3.2a3 3 0 0 1 2.5-1c1 0 1.9.3 2.4 1 .6.7 1 1.7 1 3v1.9zm-2-2c0-.8 0-1.5-.3-1.8-.2-.4-.6-.6-1-.6-.5 0-.9.2-1 .5-.3.4-.4 1-.4 1.7v2.4c0 .9 0 1.5.3 1.9.2.3.6.5 1 .5.5 0 .9-.1 1.1-.5.2-.4.3-1 .3-1.8V265zm6.5 6.1v-6h-1.1v-1.4h1v-.6c0-.9.3-1.5.8-2 .5-.4 1.1-.6 2-.6h1v1.6h-.6c-.8 0-1.2.3-1.2 1v.6h1.5v1.5h-1.5v5.9h-2zm6.3-9.2v1.8h1.3v1.5h-1.3v3.6c0 .3 0 .5.2.6 0 .2.3.2.6.2h.5v1.5a4 4 0 0 1-1.1.1c-1.4 0-2.1-.7-2.2-2v-4h-1v-1.5h1v-1.8h2z"
})));

var SvgAltitude = function SvgAltitude(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 398 407",
    width: 398,
    height: 407,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAltitude, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/altitude.a45bc941.svg";
export { ForwardRef as ReactComponent };